// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageCss_i6k4oi6{width:170px;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/ChurchLogo.css"],"names":[],"mappings":"AAAA,kBAAkB,WAAW,CAAC","sourcesContent":[".imageCss_i6k4oi6{width:170px;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
